// Etiketler: renk paleti ve yardımcılar. Maillerde etiket IMAP anahtar sözcüğü `$NWL<id>` olarak saklanır.
export const LABEL_COLORS = [
  { id: 'blue', name: 'Mavi', dot: 'bg-blue-500', chip: 'bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-200' },
  { id: 'green', name: 'Yeşil', dot: 'bg-emerald-500', chip: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-200' },
  { id: 'purple', name: 'Mor', dot: 'bg-violet-500', chip: 'bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-200' },
  { id: 'amber', name: 'Turuncu', dot: 'bg-amber-500', chip: 'bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-200' },
  { id: 'red', name: 'Kırmızı', dot: 'bg-red-500', chip: 'bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-200' },
  { id: 'pink', name: 'Pembe', dot: 'bg-pink-500', chip: 'bg-pink-100 text-pink-800 dark:bg-pink-500/20 dark:text-pink-200' },
  { id: 'teal', name: 'Turkuaz', dot: 'bg-teal-500', chip: 'bg-teal-100 text-teal-800 dark:bg-teal-500/20 dark:text-teal-200' },
  { id: 'gray', name: 'Gri', dot: 'bg-slate-500', chip: 'bg-slate-200 text-slate-800 dark:bg-slate-500/25 dark:text-slate-200' },
];

export const colorOf = (id) => LABEL_COLORS.find((c) => c.id === id) || LABEL_COLORS[0];

const PREFIX = '$nwl';

// Sanal klasör kimliği: "label:12" (gelen kutusunda o etiketi taşıyan mailler)
export const labelFolderId = (labelId) => `label:${labelId}`;
export const isLabelFolder = (folderId) => typeof folderId === 'string' && folderId.startsWith('label:');
export const labelIdOfFolder = (folderId) => (isLabelFolder(folderId) ? Number(folderId.slice(6)) : null);

// Mailin anahtar sözcüklerinden, kullanıcının etiketlerine karşılık gelenler (etiket listesi sırasıyla)
export const labelsOfKeywords = (keywords, labels) => {
  const ids = new Set(
    (keywords || [])
      .filter((k) => k.toLowerCase().startsWith(PREFIX))
      .map((k) => Number(k.slice(PREFIX.length))),
  );
  return (labels || []).filter((l) => ids.has(l.id));
};

export const keywordOf = (labelId) => `$NWL${labelId}`;

// Anahtar sözcük listesinde etiket ekle/çıkar (iyimser güncelleme için)
export const withLabelChange = (keywords, addIds = [], removeIds = []) => {
  const removed = new Set(removeIds.map((id) => keywordOf(id).toLowerCase()));
  const kept = (keywords || []).filter((k) => !removed.has(k.toLowerCase()));
  const have = new Set(kept.map((k) => k.toLowerCase()));
  addIds.forEach((id) => { if (!have.has(keywordOf(id).toLowerCase())) kept.push(keywordOf(id)); });
  return kept;
};
